import { AppearanceTypeEnum } from "commons/enum/appearance-type";
import { BranchEnum } from "commons/enum/branch-enum";
import { PrintPaperSPUnitEnum } from "commons/enum/foil-unit";
import { InspectionConclusionEnum } from "commons/enum/inspection";
import { numberFormatAsString } from "commons/ultilities";
import { OptionItem } from "commons/ultilities/dynamic-form/models/control";
import { IProductProperties } from "mobx-stores/_models/products/product";

export const getInspectionConclusionStatus = (): OptionItem[] => {
  return [
    {
      value: InspectionConclusionEnum.None,
      label: "-",
    },
    {
      value: InspectionConclusionEnum.Passed,
      label: "Đạt",
    },
    {
      value: InspectionConclusionEnum.Failed,
      label: "Không đạt",
    },
  ];
};

export const createQuantification = (product: IProductProperties): string => {
  const first = `${product.material?.paperType || ""} ${
    product.material?.gsmStandard || ""
  }`;
  let last = "";
  if (
    first.trim().length > 0 &&
    (product.material?.gsmLower || product.material?.gsmUpper)
  ) {
    last = ` (${numberFormatAsString(
      product.material?.gsmLower?.toString() || "",
      {
        decimalScale: 0,
      },
    )} - ${numberFormatAsString(product.material?.gsmUpper?.toString() || "", {
      decimalScale: 0,
    })})`;
  }
  return ((first || "") + (last || "")).trim();
};

export const getLabelOfConclusionStatus = (
  conclusionStatus: InspectionConclusionEnum,
) => {
  if (conclusionStatus === InspectionConclusionEnum.None) {
    return "";
  }

  if (conclusionStatus === InspectionConclusionEnum.Passed) {
    return "Đạt";
  }

  if (conclusionStatus === InspectionConclusionEnum.Failed) {
    return "Không đạt";
  }
  return "";
};

export const getLabelOfAppearance = (appearance: AppearanceTypeEnum) => {
  if (appearance === AppearanceTypeEnum.Box) {
    return "Thùng hàng sạch, không bụi.";
  }

  if (appearance === AppearanceTypeEnum.Tray) {
    return "Khay hàng sạch, không bụi.";
  }

  return "";
};

export const getLabelOfBranch = (branch: string) => {
  if (branch === BranchEnum.CuChi) {
    return "Củ Chi";
  }

  if (branch === BranchEnum.TaUyen) {
    return "Tạ Uyên";
  }

  return "";
};

export const getLabelOfPrintPaperSPUnit = (
  printPaperSPUnit: PrintPaperSPUnitEnum,
) => {
  if (printPaperSPUnit === PrintPaperSPUnitEnum.Box) {
    return "hộp/ bản in";
  }

  if (printPaperSPUnit === PrintPaperSPUnitEnum.prescription) {
    return "toa/ bản in";
  }

  return "";
};

export const conclusionDefautText =
  "Lô hàng trên đạt chất lượng theo tiêu chuẩn cho giao hàng.";
